import React from 'react';
import './LawraLogo.css';

const LawraLogo = () => {
  return (
    <div className="lawra-logo-container">
      <h1 className="lawra-logo">
        <span className="lawra-letter" style={{ '--delay': '0s', '--wave-delay': '0s' }}>L</span>
        <span className="lawra-letter" style={{ '--delay': '0.1s', '--wave-delay': '0.6s' }}>A</span>
        <span className="lawra-letter" style={{ '--delay': '0.2s', '--wave-delay': '1.2s' }}>W</span>
        <span className="lawra-letter" style={{ '--delay': '0.3s', '--wave-delay': '1.8s' }}>R</span>
        <span className="lawra-letter" style={{ '--delay': '0.4s', '--wave-delay': '2.4s' }}>A</span>
      </h1>
    </div>
  );
};

export default LawraLogo;
